import { AxiosError } from 'axios';
import { EXPRESS_API } from 'configs/api/expressApi';
import { successToast } from 'lib/components/toasts/success';
import { useToastError } from 'lib/hooks';
import { useMutation, useQueryClient } from 'react-query';
import { scheduleListKeys } from './scheduleListKeys';
import { useTranslation } from 'react-i18next';

const deleteMultipleSchedules = async (ids: number[]) => {
  const response = await EXPRESS_API.delete(`/schedule`, {
    data: ids,
  });
  return response.data;
};

export const useDeleteMultipleSchedulesMutation = () => {
  const { showError } = useToastError();
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  return useMutation(deleteMultipleSchedules, {
    onSuccess: () => {
      successToast({ title: t('Scheduled items deleted successfully') });
      queryClient.invalidateQueries(scheduleListKeys.lists());
    },
    onError: (err: AxiosError) => {
      showError(err);
    },
  });
};
